export enum EFont {
  Montserrat = 'Montserrat',
  Playfair_Display = 'Playfair Display',
}
